import { Link } from "react-router-dom";
import { ArrowUpRight } from "lucide-react";
import { useLanguage } from "@/context/LanguageContext";
import { usePageTitle } from "@/lib/seo";
import { SOLUTIONS } from "@/data/solutions";
import { Reveal } from "@/components/Reveal";
import { CTASection } from "@/components/CTASection";

export default function Solutions() {
  const { t, lang } = useLanguage();
  usePageTitle(t.meta.solutions);

  return (
    <div data-testid="solutions-page" className="pt-24">
      <section className="mx-auto max-w-7xl px-6 pb-20 pt-16 md:px-10 md:pt-24">
        <Reveal>
          <p className="flex items-center gap-3 text-xs uppercase tracking-[0.25em] text-bronze md:text-sm">
            <span className="h-px w-10 bg-bronze" />
            {t.solutionsPage.overline}
          </p>
          <h1 className="mt-8 max-w-4xl font-serif text-5xl leading-[0.95] tracking-tight text-ink md:text-6xl lg:text-7xl">
            {t.solutionsPage.heading}
          </h1>
          <p className="mt-8 max-w-2xl text-base leading-relaxed text-stone md:text-lg">{t.solutionsPage.sub}</p>
        </Reveal>
      </section>

      <section className="border-t border-line">
        {SOLUTIONS.map((s, i) => (
          <Reveal key={s.slug}>
            <Link
              data-testid={`solutions-row-${s.slug}`}
              to={`/solutii/${s.slug}`}
              className="group relative block border-b border-line transition-colors duration-500 hover:bg-sand/60"
            >
              <div className="mx-auto flex max-w-7xl flex-col gap-6 px-6 py-12 md:flex-row md:items-center md:gap-12 md:px-10 md:py-16">
                <span className="font-serif text-6xl leading-none text-bronze/20 transition-colors duration-500 group-hover:text-bronze/50 md:text-7xl">
                  0{i + 1}
                </span>
                <div className="relative hidden h-28 w-44 shrink-0 overflow-hidden md:block">
                  <img
                    src={s.image}
                    alt={s[lang].name}
                    loading="lazy"
                    className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-110"
                  />
                </div>
                <div className="flex-1">
                  <h2 className="font-serif text-3xl text-ink transition-colors duration-300 group-hover:text-bronze md:text-4xl">
                    {s[lang].name}
                  </h2>
                  <p className="mt-3 max-w-xl text-sm leading-relaxed text-stone md:text-base">{s[lang].short}</p>
                </div>
                <span className="flex h-14 w-14 shrink-0 items-center justify-center border border-line transition-all duration-500 group-hover:border-bronze group-hover:bg-bronze">
                  <ArrowUpRight className="h-6 w-6 text-bronze transition-colors duration-500 group-hover:text-ink" />
                </span>
              </div>
            </Link>
          </Reveal>
        ))}
      </section>

      <CTASection />
    </div>
  );
}
